import { render, staticRenderFns } from "./ChooseModal.vue?vue&type=template&id=4c724ed0&"
import script from "./ChooseModal.vue?vue&type=script&lang=js&"
export * from "./ChooseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports